module.exports = __webpack_public_path__ + "static/img/happiness.95b006a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/happiness.png
// module id = 292
// module chunks = 1